/**
 * Konfig pre finalnu fazu
 */
export const finishPhaseConfig = {

  /** po kolkych framoch sa zacne emocia */
  startAnimationEndAfterFrames: 10
}
